import { render, staticRenderFns } from "./GalleriesSection.vue?vue&type=template&id=93558f82&scoped=true&"
import script from "./GalleriesSection.vue?vue&type=script&lang=js&"
export * from "./GalleriesSection.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesSection.vue?vue&type=style&index=0&id=93558f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93558f82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VContainer,VIcon,VSheet})
